<template>
  <div class="mt30  mr60 " style="overflow:auto; height:800px;">
    <!-- <h1 class=" lh23 pa16" style="background-color:#fafafa;">组织架构</h1> -->
    <a-tree
      :show-line="true"
      :show-icon="true"
      :autoExpandParent="true"
      :tree-data="treeData"
      v-model:selectedKeys="selectedKeys"
      v-model:expandedKeys="expandedKeys"
    >
    </a-tree>
  </div>
</template>
<script>
import { onMounted, reactive, ref, toRefs, watch } from 'vue'
import { menu_list_get } from 'server/modules/351.js'

export default {
  setup(props, context) {
    const { emit } = context
    const selectedKeys = ref([])

    const state = reactive({
      treeData: [],
      expandedKeys: []
    })
    // watch(expandedKeys, () => {
    //   console.log('expandedKeys', expandedKeys)
    // })
    watch(selectedKeys, val => {
      emit('select', val)
      console.log('selectedKeys', selectedKeys)
    })
    /**
     * 重组组织架构
     */
    const recombineData = list => {
      let arr = []

      list.forEach(element => {
        const { id, parentId, menuName, childrenList } = element
        parentId === 0 && state.expandedKeys.push(id)
        arr.push({
          key: id,
          title: menuName,
          children: (childrenList && recombineData(childrenList)) || []
        })
      })
      return arr
    }
    /**
     * 获取组织架构
     */
    const getDepartTree = async () => {
      const { success, data } = await menu_list_get({
        parentId: 0,
        menuTypeStart: 0,
        menuTypeEnd: 2
      })
      if (success) {
        const { list } = data
        state.treeData = recombineData(list)
      }
    }
    onMounted(() => {
      getDepartTree()
    })

    return {
      ...toRefs(state),
      selectedKeys
    }
  }
}
</script>
<style lang="scss" scoped>
.mw300 {
  min-width: 300px;
}
.pa16 {
  padding: 16px;
}
.lh23 {
  line-height: 23px;
}
::-webkit-scrollbar {
  height: 7px;
  width: 0;
}
::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  height: 2px;

  background: #ededed;
}
::-webkit-scrollbar-thumb {
  border-radius: 20px;

  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
}
</style>
<style lang="scss">
.portal-ant-tree {
  li {
    .portal-ant-tree-node-content-wrapper {
      height: 30px;
      line-height: 30px;
    }
    span.portal-ant-tree-switcher {
      height: 30px;
      line-height: 30px;
    }
  }
}
</style>
